import { PageData } from 'server/routes/page/types';
import { LayoutConfigState } from 'js/model/state/layout';

export function initLayout(pageData: PageData): LayoutConfigState {
  if (!pageData.layoutConfig) {
    return [];
  }
  return [pageData.layoutConfig];
}
